import { DataQualityMetricsOptions } from "@/domains/dataQuality/dataQualityOptions";

export const DataQualityTexts = {
  [DataQualityMetricsOptions.MissingValues]: "Missing values",
  [DataQualityMetricsOptions.UnseenValues]: "Unseen values",
};
